import { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useParams,
} from "react-router-dom";
import { Accessibility } from "./pages/Accessibility.tsx";
import { AppPage } from "./pages/AppPage.tsx";
import { EventPage } from "./pages/EventPage.tsx";
import { Landing } from "./pages/Landing.tsx";
import { PaymentCancelled } from "./pages/PaymentCancelled.tsx";
import { PaymentSuccess } from "./pages/PaymentSuccess.tsx";
import { Privacy } from "./pages/Privacy.tsx";
import { Terms } from "./pages/Terms.tsx";
import { Docs } from "./pages/Docs.tsx";
import { pageTitleForPath } from "../../src/pageTitle.ts";
import { agentFomoDomain } from "../../constants.ts";

const ShortLinkRedirect = () => {
  const { slug } = useParams<{ slug: string }>();
  useEffect(() => {
    if (slug && /^[a-f0-9]{6}$/i.test(slug)) {
      globalThis.location.replace(`https://${agentFomoDomain}/${slug}`);
    }
  }, [slug]);
  return null;
};

export const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = pageTitleForPath({
      pathname,
      eventData: globalThis.__EVENT_DATA__,
      language: globalThis.__EVENT_LANG__,
    });
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/app" element={<Navigate to="/events" replace />} />
      <Route path="/events" element={<AppPage />} />
      <Route path="/stats" element={<AppPage />} />
      <Route path="/promote" element={<AppPage />} />
      <Route path="/subscriptions" element={<AppPage />} />
      <Route path="/friends" element={<AppPage />} />
      <Route path="/settings" element={<AppPage />} />
      <Route path="/event/:id" element={<EventPage />} />
      <Route path="/swipe" element={<AppPage />} />
      <Route path="/admin" element={<AppPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="/privacy-he"
        element={<Navigate to="/privacy?lang=he" replace />}
      />
      <Route path="/privacy-en" element={<Navigate to="/privacy" replace />} />
      <Route path="/terms" element={<Terms />} />
      <Route
        path="/terms-he"
        element={<Navigate to="/terms?lang=he" replace />}
      />
      <Route path="/terms-en" element={<Navigate to="/terms" replace />} />
      <Route path="/accessibility" element={<Accessibility />} />
      <Route
        path="/accessibility-he"
        element={<Navigate to="/accessibility?lang=he" replace />}
      />
      <Route
        path="/accessibility-en"
        element={<Navigate to="/accessibility" replace />}
      />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-cancelled" element={<PaymentCancelled />} />
      <Route path="/docs" element={<Docs />} />
      <Route path="/:slug" element={<ShortLinkRedirect />} />
    </Routes>
  );
};
